// Endpoints (routes) de la API (backend)

/** EVENTOS */
const endpointsEventos = {
  GET_ALL_EVENTOS: 'api/eventos',
  DELETE_EVENTO: (id) => `api/eventos/delete/${id}`,
  NEW_EVENTO: 'api/eventos/create',
  UPDATE_EVENTO: 'api/eventos/update',
}

/***** BUSINESSUNITS (Unidades de Negocio)   *****/
const endpointsBusinessunits = {
  GET_ALL_BUSINESSUNITS: 'api/businessunits',
  GET_ALL_BUSINESSUNITS_MINE: 'api/businessunits/getallmine',
  ALL_BUSINESSUNITS: 'api/businessunits',
  DELETE_BUSINESSUNIT: (id) => `api/businessunits/delete/${id}`,
  NEW_BUSINESSUNIT: 'api/businessunits/create',
  UPDATE_BUSINESSUNIT: 'api/businessunits/update',
}

const endpointsArticles = {
  /***** ARTICLES(Productos)   *****/
  GET_ALL_FINAL_PRODUCTS: 'api/articles/getAllFinalProducts',
  GET_ALL_FINAL_PRODUCTS_BY_SEARCH: (search, page, filterBusinessUnits) => {
    console.log("endpointsArticles - GET_ALL_FINAL_PRODUCTS_BY_SEARCH", search, page, filterBusinessUnits);
    console.log("endpointsArticles - GET_ALL_FINAL_PRODUCTS_BY_SEARCH", "api/articles/getAllFinalProductsByNameOrRef".concat(filterBusinessUnits));
    return `api/articles/getAllFinalProductsByNameOrRef/${search}/${page > 1 ? page : "1"}/${filterBusinessUnits}`
  },
  GET_ALL_FOLDER_PRODUCTS: 'api/articles/getAllFolderProducts',
  GET_ALL_FOLDER_PRODUCTS_BY_SEARCH: (search, page, filterBusinessUnits) => {
    console.log("endpointsArticles - GET_ALL_FOLDER_PRODUCTS_BY_SEARCH", search, page, filterBusinessUnits);
    console.log("endpointsArticles - GET_ALL_FOLDER_PRODUCTS_BY_SEARCH", "api/articles/getAllFolderProductsByNameOrRef".concat(filterBusinessUnits));
    return `api/articles/getAllFolderProductsByNameOrRef/${search}/${page > 1 ? page : "1"}/${filterBusinessUnits}`

  },
  GET_INFO_ARTICLE_BY_ID: (id) => `api/articles/GetArticleById/${id}`,
  // Devuelve los hijos de una caegoria que no tienen padre
  GET_ALL_ARTICLES_OF_A_CATEGORY: (idCategory, filterBusinessUnits) => {
    console.log("endpointsArticles - GET_ALL_ARTICLES_OF_A_CATEGORY", idCategory, filterBusinessUnits);
    return `api/articles/getbycategoryid/${idCategory}/${filterBusinessUnits}`
  },
  GET_ALL_ARTICLES_OF_A_FATHER: (idFatherID, filterBusinessUnits) =>
    `api/articles/getbyfatherid/${idFatherID}/${filterBusinessUnits}`,
  // Devulve todos los articulos que pertenecen a una categoria y que no son producto final
  GET_ALL_ATICLES_BY_ID_CATEGORY: (idCategory, filterBusinessUnits) =>
    `api/articles/getallarticlesbycategoryid/${idCategory}${filterBusinessUnits ? "/" + filterBusinessUnits : ""}`,
  NEW_ARTICLES: 'api/articles/create',
  UPDATE_ARTICLES: 'api/articles/update',
  DELETE_ARTICLES: (id) => `api/articles/delete/${id}`,
}

const endpointsArticlesDocuments = {
  /*****   ARTICLES DOCUMENTS   *****/
  DELETE_ARTICLE_DOCUMETNS: (id) => `api/articlesdocuments/delete/${id}`,
  DELETE_ARTICLE_DOCUMENTS_BY_NAME: (id, name, isImagenPortada) => `api/articlesdocuments/deletebyname/${id}/${name}/${isImagenPortada}`,
  // Devuelve la ruta para obtener una imagen de portada
  GET_ARTICLE_COVER_IMG: (id) =>
    `api/articlesdocuments/getarticleCoverImg/${id}`,
  GET_ARTICLE_IMGS: (id) => `api/articlesdocuments/getarticleImgs/${id}`,
  //ME DECUELVE TODOS LOS DOCUMENTOS DE UN ARTICULO + LOS DOCUMENTOS HEREDADOS DEL PADRE DE ESTE ARTICULO
  GET_ALL_DOCS_CASCADE_UPPER: (id) =>
    `api/articlesdocuments/getalldocuementscascadeupper/${id}`,
  //Devuleve metadatos de una ruta guardada en FTP
  GET_FILE: 'api/articlesdocuments/getftpfile',
  UPLOAD_FILES: 'api/articlesdocuments/filesupload',
}

const endpointsPresentaciones = {
  GET_ALL_PRESENTATIONS: 'api/presentations/getall',
  GET_ALL_PRESENTATIONS_MINE: 'api/presentations/getallmine',
  GET_ALL_PRESENTATIONS_BY_TITLE_PAGED: (search, page, id_Usuario) =>
    `api/presentations/getallbytitlepaged/${search}/${page}/${id_Usuario}`,
  GET_PRESENTATION_BY_ID: (id) => `api/presentations/${id}`,
  NEW_PRESENTATIONS: 'api/presentations/create',
  DELETE_PRESENTATIONS: (id) => `api/presentations/delete/${id}`,
}

const endpointsPresentacionesArticlesDoc = {
  GET_INFO_PRESENTAION_ARTICLES_DOCUMENTS_BY_ID_PRESENTATION: (id) =>
    `api/presentationsarticlesdocuments/${id}`,
  GET_DOCS_ARTICLE_Of_PRESENTATION: (idPresentation, idArticle) =>
    `api/presentationsarticlesdocuments/pres/artdoc/${idPresentation}/${idArticle}`,
  GET_PRESENTATION_ALL_DOCS: (idPresentation) =>
    `api/presentationsarticlesdocuments/pres/docs/${idPresentation}`,
  ADD_DOCS_PRODUCTS_TO_PRESENTATIONS:
    'api/presentationsarticlesdocuments/create',
  UPDATE_DOC_PRODUCTS_TO_PRESENTATIONS: (id_presentation, id_article) =>
    `api/presentationsarticlesdocuments/updateDoc/${id_presentation}/${id_article}`,
  DELETE_DOC_PRODUCT_PRESENTATION: (
    id_presentation,
    id_article,
    id_ArticuloDocumento,
  ) =>
    `api/presentationsarticlesdocuments/deleteDoc/${id_presentation}/${id_article}/${id_ArticuloDocumento}`,
  //Eliminar el producto de la presentacion
  DELETE_PRESENTATION_ARTICLES_DOCUEMNTS_BY_ID_ARTICLE: (
    id_presentation,
    id_article,
  ) =>
    `api/presentationsarticlesdocuments/deleteAllDocs/${id_presentation}/${id_article}`,
}

const endpointsContacts = {
  GET_ALL_CONTACTS: 'api/contacts/getall',
  NEW_CONTACTS: 'api/contacts/create',
  GET_CONTACTS_BY_ID: (id) => `api/contacts/${id}`,
  DELETE_CONTACTS: (id) => `api/contacts/delete/${id}`,
  UPDATE_CONTACTS: 'api/contacts/update',
}

const endpointsContactHospitals = {
  GET_ALL_HOSPITAL_CONTACTS: 'api/hospitalcontacts/getall',
  GET_ALL_HOSPITAL_CONTACTS_BY_ZONE_NAME_PAGED: (page, comunidad, search) =>
    `api/hospitalcontacts/getallbyzoneornamepaged/${page}/${comunidad}/${search}`,
  NEW_CONTACTS_PRESENTATIONS: 'api/contactspresentation/create',
  // Enviar presentacion a un contacto
  SEND_PRESENTATION_TO_CONTACT: (id_ContactoPresentacion) =>
    `api/contactspresentation/sendPresentationToContact/${id_ContactoPresentacion}`,
  GET_HOSPITALS_CONTACT_BY_ID_CONTACT: (id) =>
    `api/hospitalcontacts/contactHospitalsByIdContact/${id}`,

  GET_HOSPITAL_CONTACT_NOTES: (id) => `api/hospitalcontacts/${id}/notes`,
  CREATE_HOSPITAL_CONTACT_NOTE: (id) => `api/hospitalcontacts/${id}/notes`,
  UPDATE_HOSPITAL_CONTACT_NOTE: 'api/hospitalcontacts/updateNote',
  DELETE_HOSPITAL_CONTACT_NOTE: (id, id_ContactNote) =>
    `api/hospitalcontacts/${id}/deleteNote/${id_ContactNote}`,
}

const endpointsColors = {
  GET_ALL_COLORS: 'api/colors/getall',
}

const endpointsBackOffice = {
  /*****  USERS    *****/
  ALL_USERS: 'api/users',
  NEW_USER: 'api/users/newuser',
  UPDATE_USER: 'api/users/updateUser',
  DELETE_USER_BY_IDUSER: (id) => `api/users/${id}`,
  GET_USER_BY_IDUSER: (id) => `api/users/${id}`,
  /***** SPECIALTIES  *****/
  GET_ALL_SPECIALTIES: 'api/specialties/getall',
  DELETE_SPECIALTIES: (id) => `api/specialties/delete/${id}`,
  UPDATE_SPECIALTIES: 'api/specialties/update',
  NEW_SPECIALTIES: 'api/specialties/create',
  GET_CONFIG_AUTH_STATE_PESENTATION_CONTACT:
    'api/configuration/getValueAuthPresentContac',
  UPDATE_CONFIG_AUTH_STATE_PESENTATION_CONTACT:
    'api/configuration/changeValuAuthPresentContac',
}

const endpoints = {
  // GENERAL
  EXPORT_CSV: (entity) => `/api/${entity}/export/`,
  /*****   AUTH  *****/
  AUTHENTICATE: 'api/authenticate/authenticate',
  RESET_PASSWORD: 'api/authenticate/resetpassword',
  FORGOT_PASSWORD: 'api/authenticate/forgotpassword',

  /*****  USERS    *****/
  GET_PROFILE_USER_AUTH: 'api/users/profileUser',
  UPDATE_USER_PROFILE: 'api/users/updateProfile',

  /*****  ROLES     *****/
  ALL_ROLES: 'api/roles',

  /*****  POSITIONS   *****/
  GET_ALL_POSITIONS: 'api/positions/getall',
  GET_POSITIONS: (id) => `api/positions/${id}`,
  NEW_POSITIONS: 'api/positions/create',
  UPDATE_POSITIONS: 'api/positions/update',
  DELETE_POSITIONS: (id) => `api/positions/delete/${id}`,

  /*****  DEPARTAMENTS    *****/
  GET_ALL_DEPARTAMENTS: 'api/departaments/getall',
  GET_DEPARTAMENTS_BY_ID: (id) => `api/departaments/${id}`,
  NEW_DEPARTAMENTS: 'api/departaments/create',
  UPDATE_DEPARTAMENTS: 'api/departaments/update',
  DELETE_DEPARTAMENTS: (id) => `api/departaments/delete/${id}`,

  /***** SPECIALTIES  *****/
  //este se deberia borrar, comprobar donde se llama
  GET_ALL_SPECIALTIES: (contactId) => `api/specialties/getall/${contactId}`,

  /*****  CATEGORIES    *****/
  GET_ALL_CATEGORIES: 'api/categories/getall',
  NEW_CATEGORIES: 'api/categories/create',
  UPDATE_CATEGORIES: 'api/categories/update',
  DELETE_CATEGORIES: (id) => `api/categories/delete/${id}`,

  /*****  HOSPITALS   *****/
  // GET_ALL_HOSPITALS: "api/hospitals/getall",
  GET_ALL_HOSPITALS: 'api/hospitals/getallhospitalbyZone',
  NEW_HOSPITALS: 'api/hospitals/create',
  UPDATE_HOSPITALS: 'api/hospitals/update',
  DELETE_HOSPITALS: (id) => `api/hospitals/delete/${id}`,
  GET_HOSPITALS_BY_ID: (id) => `api/hospitals/${id}`,
  //Devolver los hospitales de la misma zona que el usuario autentificado y todos sus contactos
  GET_ALL_HOSPITALS_AND_THEIR_CONTACTS_BY_USER_ZONE:
    'api/hospitals/getallhospitalsandcontactsbyuserzone',
  GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED: (zoneId, city, page) =>
    `api/hospitals/getallhospitalsbyzonecitypaged/${zoneId}/${city}/${page}`,
  GET_ALL_COMMUNITIES: 'api/hospitals/gethospitalcomunidades',

  /*****   HOSPITALS CONTACTS   *****/
  GET_HOSPITAL_CONTACTS_BY_ID: (id) => `api/hospitalcontacts/${id}`,

  GET_ALL_HOSPITAL_CONTACTS: (zoneId) =>
    `api/hospitalcontacts/getall/${zoneId}`,
  NEW_HOSPITAL_CONTACTS: 'api/hospitalcontacts/create',
  UPDATE_HOSPITAL_CONTACTS: 'api/hospitalcontacts/update',
  DELETE_HOSPITAL_CONTACTS: (id) => `api/hospitalcontacts/delete/${id}`,

  /*****  CONTACTS ESPECIALIDADES  *****/
  GET_SPECIALTIES_BY_ID_CONTACT: (id) =>
    `api/ContactsSpecialties/getbyidcontact/${id}`,
  NEW_SPECIALTIES_CONTACTS: 'api/ContactsSpecialties/create',
  DELETE_SPECIALTIES_CONTACTS: (id) => `api/ContactsSpecialties/delete/${id}`,

  /*****  TIPOS DE DOCUEMTOS DE LOS PDFS   *****/
  GET_ALL_TYPE_OF_DOCUMENTS: 'api/documents',

  /*****  ZONES  *****/
  ALL_ZONES: 'api/zones',

  /*****  TASKS *****/
  GET_ALL_TASKS: (userId = 0, eventId = 0) =>
    `api/CRMs/getall/${userId}/${eventId}`,
  GET_ALL_TASKS_BY_EVENT_PAGED: (userId = 0, eventId = 0, search, page) =>
    `api/CRMs/getallbyeventpaged/${userId}/${eventId}/${search}/${page}`,
  GET_TASKS_BY_ID: (id) => `api/CRMs/${id}`,
  NEW_TASKS: 'api/CRMs/create',
  UPDATE_TASKS: 'api/CRMs/update',
  DELETE_TASKS: (id) => `api/CRMs/delete/${id}`,

  /***** FASES    *****/
  GET_ALL_PHASES: 'api/phases',

  /***** TIPO DE ASUNTOS  *****/
  GET_ALL_EVENTS: 'api/events',

  /***** CONTACTOS PRESENTACION   *****/

  /*****  TIME SLOTS    *****/
  ALL_TIMESLOTS: 'api/timeslots',

  /*****  LGPD  *****/
  READ_LGPD_POLICY: (ref) => `api/Lgpd/set/${ref}`,
  ACCEPT_LGPD_POLICY: (ref) => `api/Lgpd/set/${ref}/1`,
  REJECT_LGPD_POLICY: (ref) => `api/Lgpd/set/${ref}/2`,
}

export {
  endpoints,
  endpointsBusinessunits,
  endpointsEventos,
  endpointsArticlesDocuments,
  endpointsArticles,
  endpointsPresentaciones,
  endpointsPresentacionesArticlesDoc,
  endpointsColors,
  endpointsBackOffice,
  endpointsContactHospitals,
  endpointsContacts,
}
